import React from 'react'

import { toPx } from 'common/builder/components/chart/utils/toPx'

const BORDER_RADIUS = 20

export const ImagePreview: React.CSSProperties = {
  borderRadius: toPx(BORDER_RADIUS),
}

export const ImagePreviewWithButtons: React.CSSProperties = {
  borderRadius: `${toPx(BORDER_RADIUS)} ${toPx(BORDER_RADIUS)} 0 0`,
}
